import { testDataCreator } from '@wix/answers-lib';
import { CreditCardType, PaymentType } from '.';
import { RandomGenerator } from '../../test-utils';
export var creditCardPaymentMethodBuilder = testDataCreator(function () {
    return {
        type: PaymentType.CreditCard,
        isDefault: true,
        cardNumber: "***********" + RandomGenerator.randomNumber(1000, 9999),
        cardType: CreditCardType.AmericanExpress,
        nameOnCard: RandomGenerator.randomName()
    };
});
export var paymentMethodBuilder = testDataCreator(function () {
    return {
        type: PaymentType.BankTransfer,
        isDefault: true,
    };
});
//# sourceMappingURL=builder.js.map